import React from 'react'
import { Backdrop, CircularProgress } from '@mui/material'

function Loading() {
    return (
        <div>
            <Backdrop
                sx={{
                    color: '#fff',
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                    backgroundColor: 'rgba(0, 0, 0, 0.75)'
                }}
                open
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    )
}

export default Loading
